import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { watchCourseContentChanges } from 'lib/courseContentChanges';
import { Loading, useRemote } from "../workspace/Controls";
import SpeakerProfilePage from "pages/SpeakerProfilePage";
import WebinarCourseDetailPage from "pages/WebinarCourseDetailPage";
export default function ContentPreview() {
  const { domain, id } = useParams();
  const valid = ["speakers", "course-library"].includes(domain);
  const [revision, setRevision] = useState(0);
  useEffect(() => domain === 'course-library' ? watchCourseContentChanges(() => setRevision(value => value + 1)) : undefined, [domain]);
  const state = useRemote(
    valid ? `/admin/content-preview/${domain}/${encodeURIComponent(id)}` : null,
    revision,
    { keep: domain === 'course-library' },
  );
  return (
    <div className="bg-canvas pt-20 text-ink">
      <div className="border-b border-ink/10 px-6 py-5">
        <Link to={`/admin/${domain}/${id}`} className="text-accent-ink">
          ← Back to editor
        </Link>
        <p>
          Saved content preview · {state.data?.actualStatus || "Loading"} · Not
          a public link
        </p>
      </div>
      <Loading state={state}>
        {state.data?.content ? (
          domain === "speakers" ? (
            <SpeakerProfilePage previewRecord={state.data.content} />
          ) : (
            <WebinarCourseDetailPage previewRecord={state.data.content} />
          )
        ) : (
          <p role="status">No complete content is available to preview.</p>
        )}
      </Loading>
    </div>
  );
}
